
















































import { Component, Vue, Watch, Provide } from 'vue-property-decorator';
import {timeFormat} from "@/utils";
@Component({
    name: 'dashboardScreen'
})
export default class PerformanceDashboard extends Vue {
    @Provide() private token: any = "";
    @Provide() private userid: any = "";
    @Provide() private seniorleaderstatsList: any = [];
    @Provide() private updatedTime: any = ""; // 上次更新时间
    @Provide() private timeId: any = null; // 1 组  2 个人
    @Provide() private MorkResultData: any = [{
        Id: 1111,
        ExtNumber: 1111,
        Utime: 1111,
        Supplier: 1111
    }];
    @Provide() private isMorked: boolean = false; // lee 模拟数据
    @Provide() private resultPersonalData: any = [];
    @Provide() private resultGroupData: any = [];
    @Provide() private chartPerson: any = [];
    @Provide() private chartData: any = [];
    @Provide() private chartGroup: any = [];
    @Provide() private roleType: number = 0; // 1 组  2 个人
    private mounted() {
        this.token = localStorage.getItem("token");
        // this.userid = localStorage.getItem("token");
        this.userid = this.getUid()?this.getUid():localStorage.getItem("userid"); // 如果在url上匹配到uid即为组长查看组员的dashaboard
        this.forList(); // 获取列表数据
    }
    private destroyed() {
        let _id = this.timeId;
        clearTimeout(_id);
    }
    private forList() {
        this.getExtenList();
        this.timeId = setTimeout(() => {
            this.forList(); // 获取列表数据
        }, 300000);
    }
    private getUid() {
        if(this.$route.query&&this.$route.query.uid){
            return this.$route.query.uid;
        }
        return ""
    }
    private async getExtenList() {
        let _arg = {
            trackId: "",
            clientId: "",
            token: this.token,
            userid: Number(this.userid)
        }
        const { getUrgeDashboardApi }: any = await import("@/request/dashboard");
        let res = await getUrgeDashboardApi(_arg);
        if(res){
            this.roleType = res.roletype;
            this.groupList(res);
        }
    }
    private groupList(data: any){
        if(data && data.leaderstatsList) {
            let _result_group: any = typeof data.leaderstatsList == 'object'?data.leaderstatsList:JSON.parse(data.leaderstatsList);
            this.resultGroupData =_result_group;
        }
        if(data && data.staffstatsList) {
            let _result_person: any = typeof data.staffstatsList == 'object'?data.staffstatsList:JSON.parse(data.staffstatsList);
            this.resultPersonalData =_result_person;
        }
        if(data && data.seniorleaderstatsList) {
            let _result_seniorleader: any = typeof data.seniorleaderstatsList == 'object'?data.seniorleaderstatsList:JSON.parse(data.seniorleaderstatsList);
            this.seniorleaderstatsList =_result_seniorleader;
        }
        console.log(data, "groupList");
        this.chartPerson = data.pies;
        this.updatedTime = timeFormat(this.chartPerson.updatetime);
        console.log(this.chartPerson, "chat");
    }
}
